export const TR = {
  "Open document": "Belgeyi aÃ§",
  "Upload file": "Dosya yÃ¼kleme",
  "Drop file here to upload": "YÃ¼klemek iÃ§in dosyayÄ± buraya bÄ±rakÄ±n",
  "Disc": "Disk",
  "URL": "URL",
  "FILE": "DOSYA",
  "SIZE": "BOY",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "bayt",
  "Loading... Please wait.": "YÃ¼kleniyor lÃ¼tfen bekleyin.",
  "Fit Width": "SÄ±ÄdÄ±r GeniÅliÄi",
  "Fit Height": "Uygun YÃ¼kseklik",
  "Password protected document": "Parola korumalÄ± belge",
  "Password": "Parola",
  "Open": "AÃ§Ä±k",
  "Password Required": "Åifre gerekli",
  "Incorrect password": "yanlÄ±Å parola",
  "Error": "Hata",
  "Something went wrong": "Bir Åeyler yanlÄ±Å gitti",
  "Server is not available": "Sunucu kullanÄ±lamÄ±yor",
  "of": "ile ilgili",
  "Please wait...": "LÃ¼tfen bekle..."
};
